export default () => {
	const { location: { href } } = window;
	let env = 'local';

	if (href.includes('-dev'))
		env = 'dev';
	else if (href.includes('dev.'))
		env = 'dev';
	else if (href.includes('-stg'))
		env = 'stg';
	else if (href.includes('stg.'))
		env = 'stg';
	else if (href.includes('-sandbox'))
		env = 'sandbox';
	else if (href.includes('sandbox.'))
		env = 'sandbox';
	else if (href.includes('posillicocms.com'))
		env = 'prod';
	else if (href.includes('posillico-cms.netlify'))
		env = 'prod';

	return env;
};
